import { flow, types } from 'mobx-state-tree'
import { ToastType } from '../../../comps/Toast'
import { addNewCustomerDetailsApi } from '../../../network/DomesticMoneyTransfer/addNewCustomerDetailsApi'
import {
  checkWhetherTheCustomerExistsApi,
  CUSTOMER_VALIDATION_CODES,
} from '../../../network/DomesticMoneyTransfer/checkWhetherTheCustomerExistsApi'
import { fetchRemittanceCustomerDetailsApi } from '../../../network/DomesticMoneyTransfer/fetchRemittanceCustomerDetailsApi'
import { getDmtAvailableLimitApi } from '../../../network/DomesticMoneyTransfer/getDmtAvailableLimitApi'
import { DomesticMoneyTransferStrings } from '../../../screens/DomesticMoneyTransfer/Strings'
import { RootStore } from '../../store'
import { getPinCodeInfo } from './../../../network/DomesticMoneyTransfer/getPinCodeInfo'

const CustomerDetails = types
  .model('CustomerDetails', {
    firstName: types.optional(types.string, ''),
    lastName: types.optional(types.string, ''),
    dob: types.optional(types.string, ''),
    mobile: types.optional(types.string, ''),
    street: types.optional(types.string, ''),
    doorNumber: types.optional(types.string, ''),
    pinCode: types.optional(types.string, ''),
    city: types.optional(types.string, ''),
    state: types.optional(types.string, ''),
    occupation: types.optional(types.string, ''),
    remittanceUserId: types.optional(types.string, ''),
    newRemittanceUserId: types.optional(types.string, ''),
    aadhaarToken: types.optional(types.string, ''),
  })
  .actions((self) => ({
    clearNewRemittanceUserId() {
      self.newRemittanceUserId = null
      self.remittanceUserId = null
    },
    checkWhetherTheCustomerExists: flow(function* checkWhetherTheCustomerExists(mobile) {
      try {
        const response = yield checkWhetherTheCustomerExistsApi(RootStore.moneyTransferSession.getTokens, mobile)
        console.log('htag response', response)
        if (response?.code === CUSTOMER_VALIDATION_CODES?.DOES_NOT_EXIST) {
          RootStore.message.setMessage(
            DomesticMoneyTransferStrings.createNewUser ?? '',
            ToastType?.POSITIVE?.toUpperCase(),
          )
        }
        self.remittanceUserId = response?.remittanceUserId
        self.aadhaarToken = response?.aadharToken
        self.firstName = response?.firstName
        self.lastName = response?.lastName
        self.mobile = mobile
        return response
      } catch (err) {
        RootStore.message.handleError(err)
        throw err
      }
    }),
    fetchRemittanceCustomerDetails: flow(function* fetchRemittanceCustomerDetails(data: any) {
      try {
        const response = yield fetchRemittanceCustomerDetailsApi(RootStore.moneyTransferSession.getTokens, data)
        self.remittanceUserId = response?.data?.remittanceUserId
        return response
      } catch (err) {
        RootStore.message.handleError(err)
        throw err
      }
    }),
    getAvailableLimitAsync: flow(function* getAvailableLimitAsync() {
      try {
        const response = yield getDmtAvailableLimitApi(RootStore.moneyTransferSession.getTokens, self.remittanceUserId)
        return response
      } catch (err) {
        RootStore.message.handleError(err)
        throw err
      }
    }),
    getPinCodeInfoAsync: flow(function* getPinCodeInfoAsync(pincode: any) {
      try {
        const response = yield getPinCodeInfo(pincode, RootStore.moneyTransferSession.getTokens)
        return response
      } catch (err) {
        throw err
      }
    }),

    addNewCustomerDetails: flow(function* addNewCustomerDetails(body: any, authorizationCode: string) {
      try {
        const response = yield addNewCustomerDetailsApi(
          RootStore.moneyTransferSession.getTokens,
          body,
          authorizationCode,
        )
        self.newRemittanceUserId = response?.data?.remittanceUserId
        console.log(self.remittanceUserId, response, "ressscheckk:::", response?.data?.remittanceUserId)
        return response
      } catch (err) {
        if (err?.code === '30032') {
          RootStore.message.showErrDialog(err.message, 'RESET_TO_DMR_HOME')
        } else {
          RootStore.message.handleError(err)
        }
        throw err
      }
    }),

    updateCustomerData(data: any) {
      self.firstName = data?.firstName
      self.lastName = data?.lastName
      self.dob = data?.dob
      self.street = data?.street
      self.pinCode = data?.pinCode
      self.city = data?.city
      self.state = data?.state
      self.doorNumber = data?.doorNumber
      self.occupation = data?.occupation
      self.aadhaarToken = data?.aadhaarToken
    },
  }))
  .views((self) => ({}))

const CustomerDetailsData = CustomerDetails.create({})

export { CustomerDetails, CustomerDetailsData }

